// Phase 4a customer-portal AC-9. The banner ships UI-ready against
// the `User#delinquent?` predicate, which is stubbed to `false` in
// v1. When 4b-ar-and-dunning lands, the predicate flips and this
// banner renders without any further frontend change.
//
// V1 visual + copy mirrors the spec's "red banner with outstanding
// balance + Pay now CTA" pattern but uses placeholder copy because
// 4b hasn't defined the exact balance source yet.
export function DelinquentBanner(): JSX.Element {
  return (
    <div
      role="alert"
      data-testid="delinquent-banner"
      className="rounded border border-red-600 bg-red-50 p-3 text-sm text-red-900"
    >
      <strong>Outstanding balance.</strong>{" "}
      Reorder + extension are disabled until your invoice is paid.{" "}
      <a className="ml-2 underline" href="/portal/profile#payment">
        Pay now
      </a>
    </div>
  );
}
